import AsyncStorage from "@react-native-async-storage/async-storage"

export const AsyncStorageKey = {
    garAccessToken: "garAccessToken",
    mood: "mood",
    upgrade: "upgrade",
    userData: "userData",
    gdprConsent: "gdprConsent",
    adminData: "adminData",
    notificationData: "notificationData",
    appMenuContext: "appMenuContext"
}

//const storage = createAsyncStorage("liliAppDB");

export const getItemFromAsyncStorage = async (props: { itemKey: string }) => {
    try {
        const { itemKey } = props;
        const dataAsString: string | null | undefined = await AsyncStorage.getItem(itemKey);
        if ((dataAsString !== null) && (dataAsString !== undefined)) {
            const itemData: any = JSON.parse(dataAsString);
            if (itemData.data !== undefined) {
                return itemData;
            }
            return null;
        }
        return null;
    } catch (error) {
        throw error;
    }
}

export const setItemToAsyncStorage = async (props: { itemKey: string; item: any }) => {
    try {
        const { itemKey, item } = props;
        await AsyncStorage.setItem(itemKey, JSON.stringify({data:item, ts: new Date().getTime()}));
    } catch (error) {
        throw error;
    }
}

export const removeItemFromAsyncStorage = async (props: {itemKey: string}) => {
    const { itemKey } = props;
    await AsyncStorage.removeItem(itemKey);
}

export const wipeAsyncStorage = async () => {
    await AsyncStorage.clear();
}